import mutations from "./mutations";
import actions from "./actions";
import getSafe from "../../../modules/commonModule/helpers/getSafe";

export const allShippingRequests = [];
export const formDetailsDefault = {
  id: null,
  reference_number: null
};

export const dangerousGoodDefault = {
  dangerous_good_info_id: null,
  chemical_name: null,
  sub_risk: null,
  flash_point: null,
  marine_pollutant: null,
  limited_quantity: null,
  temperature_controlled: null,
  control_temperature: null,
  emergency_temperature: null,
  empty_laden_tank: null,
  net_explosive_quantity: null,
  imdg_code_segregation_group: null,
  container_identification_number: null,
  seal_number: null,
  tare_mass: null,
  container_operator: null,
  container_type: null,
  container_size: null,
  total_gross_mass: null,
  dangerous_good_packaging: {
    gross_mass: null,
    net_mass: null,
    volume: null,
    outer_packaging: null,
    inner_packaging: null
  }
};

export const shipperAndConsigneeDetailsDefault = {
  shipper_name: null,
  shipper_address: null,
  shipper_phone_number: null,
  shipper_email: null,
  consignee_name: null,
  consignee_address: null,
  consignee_email: null,
  consignee_phone_number: null,
  ship_name: null,
  voyage_number: null,
  port_of_loading_origin: null,
  port_of_loading: null,
  port_of_loading_id: null,
  port_of_discharge_id: null,
  date_of_arrival: null,
  date_of_departure: null,
  port_of_call: null
};

export const additionalInfoAndDocsDefault = {
  additional_handling_information: null
};

export const certificateDocumentDefault = [];

export const shipperDeclarationDefault = {
  shipper_declaration_company_name: null,
  shipper_declaration_name_of_declarant: null,
  shipper_declaration_status_of_declarant: null,
  shipper_declaration_date: null
};

export const shippingRequestsStatisticsDefault = {
  awaiting_processing: 0,
  failed_processing: 0,
  pending_approval: 0,
  approved: 0,
  disapproved: 0,
  total_shipping_requests: 0
};

export const getDefaultShippingRequestObject = () => {
  return {
    form_details: {
      ...formDetailsDefault
    },
    shipper_and_consignee_details: {
      ...shipperAndConsigneeDetailsDefault
    },
    dangerous_goods: [
      {
        ...dangerousGoodDefault
      }
    ],
    additional_info_and_docs: {
      ...additionalInfoAndDocsDefault
    },
    certificate_documents: [],
    uploaded_certificate_documents: [],
    shipper_declaration: {
      ...shipperDeclarationDefault
    }
  };
};

export const getDefaultState = () => {
  return {
    searchAndFilterShippingRequests: [],
    approvedShippingRequests: [],
    shippingRequests: [],
    savedShippingRequests: [],
    shippingRequest: {
      form_details: {
        ...formDetailsDefault
      },
      shipper_and_consignee_details: {
        ...shipperAndConsigneeDetailsDefault
      },
      dangerous_goods: [
        {
          ...dangerousGoodDefault
        }
      ],
      additional_info_and_docs: {
        ...additionalInfoAndDocsDefault
      },
      certificate_documents: [
        {
          ...certificateDocumentDefault
        }
      ],
      uploaded_certificate_documents: [],
      shipper_declaration: {
        ...shipperDeclarationDefault
      }
    },
    dangerousGoodsInfo: [],
    shippingRequestStatistics: {
      ...shippingRequestsStatisticsDefault
    },
    
  };
};

export const getters = {
  getShipperAndConsigneeDetails: state => {
    return state.shippingRequest.shipper_and_consignee_details;
  },

  getDangerousGoods: state => {
    return state.shippingRequest.dangerous_goods;
  },

  getDangerousGoodsInfo: state => {
    return state.dangerousGoodsInfo;
  },

  getAdditionalInfoAndDocs: state => {
    return state.shippingRequest.additional_info_and_docs;
  },

  getCertificateDocuments: state => {
    return state.shippingRequest.certificate_documents;
  },

  shippingRequestHasBeenInitiated: state => {
    return state.shippingRequest.form_details.id !== null;
  },

  getShippingRequestID: state => {
    return getSafe(() => state.shippingRequest.form_details.id);
  },

  getShippingRequest: state => {
    return getSafe(() => state.shippingRequest);
  },

  getUploadedDocuments: state => {
    return getSafe(() => state.shippingRequest.uploaded_certificate_documents);
  },

  getShipperDeclaration: state => {
    return getSafe(() => state.shippingRequest.shipper_declaration);
  },

  getFormReferenceNumber: state => {
    return getSafe(() => state.shippingRequest.form_details.reference_number);
  },

  getShippingRequestStatistics: state => {
    return getSafe(() => state.shippingRequestStatistics);
  },

  getNoOfPendingShippingRequests: state => {
    const statisitics = state.shippingRequestStatistics;

    return statisitics.pending_approval + statisitics.awaiting_processing;
  },

  getShippingRequestByID(state) {
    return id => {

      //add to list if there is a new query or field
      let list = state.shippingRequests.concat(state.approvedShippingRequests)
      let result = list.filter(
        shippingRequest => shippingRequest.id === id
      );
      return result;
    };
  },


  getApplicationStatusHistory: state => {
    let list = state.shippingRequests;

    let result = list.map(shippingRequest => ({
      ref_no: shippingRequest.reference_number,
      id: shippingRequest.id,
      status: shippingRequest.status,
      dg_total: shippingRequest.dangerousGoods.length,
      ship_name: shippingRequest.ship_name,
      // shipper_name: shippingRequest.shipper_name,
      voyage_number: shippingRequest.voyage_number,
      shipper_declaration_date: shippingRequest.shipper_declaration_date,
      // consignee_name: shippingRequest.consignee_name
    }));
    return result;
  },
  getSearchQueryResult: state => {
    let list = state.searchAndFilterShippingRequests;

    if(list){

    let result = list.map(shippingRequest => ({
      ref_no: shippingRequest.reference_number,
      id: shippingRequest.id,
      status: shippingRequest.status,
      dg_total: shippingRequest.dangerousGoods.length,
      ship_name: shippingRequest.ship_name,
      // shipper_name: shippingRequest.shipper_name,
      voyage_number: shippingRequest.voyage_number,
      shipper_declaration_date: shippingRequest.shipper_declaration_date,
      // consignee_name: shippingRequest.consignee_name
    }));
    return result
  }
    return ;
  },

  getSavedShippingRequests: state => {
    const savedRequests = state.savedShippingRequests.map(request => {
      const data = JSON.parse(request.data);

      return {
        id: request.id,
        created_at: request.created_at,
        updated_at: request.updated_at,
        ...data
      };
    });

    return savedRequests;
  },

  getApprovedApplications: state => {
    let list = state.approvedShippingRequests;
    let result = list.map(shippingRequest => ({
      ref_no: shippingRequest.reference_number,
      id: shippingRequest.id,
      dg_total: shippingRequest.dangerousGoods.length,
      ship_name: shippingRequest.ship_name,
      status: shippingRequest.status,
      // shipper_name: shippingRequest.shipper_name,
      voyage_number: shippingRequest.voyage_number,
      shipper_declaration_date: shippingRequest.shipper_declaration_date,
      // consignee_name: shippingRequest.consignee_name
    }));
    return result;
  }
};

export default {
  namespaced: true,
  state: getDefaultState(),
  getters,
  actions,
  mutations
};
